require('normalize.css/normalize.css');
require('./styles/index.scss');

import Mouse from "./utils/mouse"
import Easing from "./utils/easing"

const canvas = document.querySelector('.main-canvas')
// const ctx = canvas.getContext("2d")

canvas.width = window.innerWidth * window.devicePixelRatio
canvas.height = window.innerHeight * window.devicePixelRatio


const ctx = canvas.getContext("2d")

let image = new Image()
image.onload = () => {
    // ctx.globalAlpha = .2
    requestAnimationFrame(update)
}
image.src = 'https://images.rtl.fr/~c/1200v800/rtl/www/1142919-un-koala-illustration.jpg'

let time = 0
const nombre = 30

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function drawCircle(angle, rad){
  ctx.beginPath()
  ctx.fillStyle = `${getRandomColor()}`
  ctx.arc(Math.cos(angle * time) * rad, Math.sin(angle * time) * rad, 10, 0, Math.PI * 2, true)
  ctx.fill()
  ctx.closePath()
}

// à chaque image : 60fps
const update = ()=>{
  requestAnimationFrame(update)

    // ctx.clearRect(0, 0, canvas.width, canvas.height )

    
    time+= 0.05

    /**
     * Rectangle avec alfa
     */
    ctx.beginPath()
    ctx.fillStyle = '#000'
    ctx.globalAlpha = .1
    ctx.rect( 0, 0, canvas.width, canvas.height)
    ctx.fill()
    ctx.globalAlpha = 1
    ctx.closePath()
    
  
    /**
     * STYLE
     */
    ctx.save();
    ctx.translate(canvas.width / 2, canvas.height /2)
    for (let k = 0; k < nombre; k++) {
      drawCircle( Math.PI * ( k * 0.1), (k * 30 * Math.sin(time * .346 )) + 20)
    }
    ctx.restore()
}
